function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { openPinModal } from "@common/actions";
import ChannelLogo from "@common/components/ChannelLogo";
import protect from "@common/components/HoC/protect";
import withSessionLock from "@common/components/HoC/withSessionLock";
import LoadProgressBar from "@common/components/LoadProgressBar";
import VerticalInfiniteScroll from "@common/components/VerticalInfiniteScroll";
import ShowsSlider from "@common/components/shows-slider/ShowsSlider";
import { parseQuery } from "@common/services/helpers";
import { SLIDER_BIG } from "@common/services/responsive";
import { checkLockStatusForChannel, checkVisibleStatusForChannel } from "@common/utils/helpers";
import { HAS_ACCESS, LIST_LEVEL_ONE, ROUTE_SEARCH, SEARCH_TYPE_ACTIVE, TOOLTIP_SHOW_DELAY } from "@config/constants";
export var SearchPage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(SearchPage, PureComponent);
    var _super = _create_super(SearchPage);
    function SearchPage(props) {
        _class_call_check(this, SearchPage);
        var _this;
        _this = _super.call(this, props);
        _this.renderSearchedShows = _this.renderSearchedShows.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(SearchPage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var userDetails = this.props.userDetails;
                dataLayer.push({
                    event: "search",
                    pageCategory: "search",
                    currentSubscription: userDetails && userDetails.subscription && userDetails.subscription[0].plan[0].cfSubscriptionClass
                });
            }
        },
        {
            /**
     * Renders the search results
     * @returns {ReactElement || null}
     */ key: "renderSearchedShows",
            value: function renderSearchedShows() {
                var _this_props = this.props, history = _this_props.history, i18n = _this_props.i18n, location1 = _this_props.location, logos = _this_props.logos, searchState = _this_props.searchState, screenType = _this_props.screenType;
                var type = parseQuery(location1.search).type;
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        type === SEARCH_TYPE_ACTIVE && searchState.filteredFuture.length > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(ShowsSlider, {
                                    className: "future-search-results",
                                    infinite: false,
                                    channelsLogos: logos,
                                    shows: searchState.filteredFuture,
                                    category: {
                                        id: "future-search-results"
                                    },
                                    i18n: i18n,
                                    route: ROUTE_SEARCH,
                                    hasLogo: true,
                                    level: LIST_LEVEL_ONE,
                                    hasTitle: true,
                                    hasStaticTitle: true,
                                    staticLinkTitle: i18n.common.upcoming,
                                    history: history,
                                    showHasLabel: true,
                                    showLiveLabel: true,
                                    responsiveKey: SLIDER_BIG,
                                    isCardBig: true
                                }),
                                searchState.filteredRecorded.length > 0 ? /*#__PURE__*/ _jsx("div", {
                                    className: "title-main margin-bottom-small",
                                    children: i18n.common.archive
                                }) : null
                            ]
                        }) : null,
                        searchState.filteredRecorded.length > 0 ? /*#__PURE__*/ _jsx(VerticalInfiniteScroll, {
                            content: searchState.filteredRecorded,
                            channelsLogos: logos,
                            history: history,
                            i18n: i18n,
                            screenType: screenType,
                            showHasLabel: true,
                            hasLogo: true,
                            isCardBig: true
                        }) : null
                    ]
                });
            }
        },
        {
            /**
     * Renders the 'no results found' message.
     * @returns {ReactElement || null}
     */ key: "renderNoResults",
            value: function renderNoResults() {
                var _this_props = this.props, i18n = _this_props.i18n, searchState = _this_props.searchState;
                var showNoResult = searchState.hasSearch && searchState.filteredFuture.length === 0 && searchState.filteredRecorded.length === 0;
                return showNoResult ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "no-results",
                            children: i18n.search.noResults
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "try-again",
                            children: i18n.search.tryAgain
                        })
                    ]
                }) : null;
            }
        },
        {
            /**
     * Renders the channels logos.
     * @returns {ReactElement || null}
     */ key: "renderChannelsLogos",
            value: function renderChannelsLogos() {
                var channelsLogosTemplate = null;
                var _this_props = this.props, logos = _this_props.logos, searchState = _this_props.searchState, profileSettings = _this_props.profileSettings, locked = _this_props.locked, unlock = _this_props.unlock, _$openPinModal = _this_props.openPinModal;
                var channelsIds = Object.keys(logos);
                var showLogos = searchState.filteredFuture.length === 0 && searchState.filteredRecorded.length === 0;
                // Show only if there are logos and either a search with
                // no results has been made or there are just no results
                // yet (the initial state before starting a `simple` search
                // (the other type is `active`).
                if (channelsIds.length > 0 && showLogos) {
                    var channelsWithAccess = {};
                    channelsIds.forEach(function(channelId) {
                        // Filter out channel logos without access or that are hidden
                        if (logos[channelId].access === HAS_ACCESS && checkVisibleStatusForChannel(profileSettings, channelId)) {
                            channelsWithAccess[channelId] = logos[channelId];
                        }
                    });
                    channelsLogosTemplate = Object.keys(channelsWithAccess).map(function(channelId) {
                        var channelLock = checkLockStatusForChannel(profileSettings, channelId);
                        var sessionLock = locked !== -1 ? locked : channelLock;
                        var onOpening = function() {
                            sessionLock && _$openPinModal({
                                onSuccess: unlock
                            });
                        };
                        return /*#__PURE__*/ _jsx(ChannelLogo, {
                            hasName: false,
                            isInSearchPage: true,
                            channelLogo: channelsWithAccess[channelId],
                            locked: sessionLock,
                            onOpening: onOpening,
                            isCentered: true
                        }, channelId);
                    });
                }
                return /*#__PURE__*/ _jsx("div", {
                    className: "channels-logos",
                    children: channelsLogosTemplate
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, logos = _this_props.logos, recorded = _this_props.recorded, screenType = _this_props.screenType;
                var query = parseQuery(location.search).query;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "search-page-component",
                    children: [
                        /*#__PURE__*/ _jsx(LoadProgressBar, {
                            items: [
                                recorded.categories,
                                logos
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "listing-container",
                            children: [
                                /*#__PURE__*/ _jsx(ReactTooltip, {
                                    id: "show-slider-tooltip",
                                    className: "tooltip",
                                    delayShow: TOOLTIP_SHOW_DELAY,
                                    disable: !screenType.web,
                                    place: "bottom",
                                    effect: "solid"
                                }),
                                this.renderSearchedShows(),
                                query && this.renderNoResults(),
                                this.renderChannelsLogos()
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return SearchPage;
}(PureComponent);
var mapStateToProps = function(param) {
    var logos = param.logos, recorded = param.recorded, searchState = param.searchState, screenType = param.screenType, userDetails = param.userDetails, profileSettings = param.profileSettings;
    return {
        logos: logos,
        recorded: recorded,
        searchState: searchState,
        screenType: screenType,
        userDetails: userDetails,
        profileSettings: profileSettings
    };
};
export default withSessionLock(protect(connect(mapStateToProps, {
    openPinModal: openPinModal
})(SearchPage)));
